import apiClient from 'clients/apiClient';
import config from 'helpers/config';

/**
 * Fetch reservations request from payload.
 *
 * @param {Object} payload
 * @returns {Promise}
 */
export const fetchReservationsRequest = (payload) => {
    const url = `${ config.getApiBaseUrl() }/reservations`;

    return apiClient.read(url, payload);
};


// WEBPACK FOOTER //
// ./src/http/requests/reservations/reservationsRequests.js